module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aDIEe8/images/cover.jpg?1684515200051",
      "alt": "This image is the cover for the book Basic Christianity"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Basic Christianity\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("World-renowned preacher John Stott in this book clearly defines both the fundamental claims of Christianity and the proper out-workings of those basic beliefs in the daily lives of believers. Stott's "), _c('i', [_vm._v("Basic Christianity")]), _vm._v(" is a sound, sensible guide for anyone seeking an intellectually satisfying presentation of the Christian faith."), _c('br'), _c('br'), _vm._v(" Named one of the Top 100 Books of the Millennium by "), _c('i', [_vm._v("World")]), _vm._v(" magazine and listed among "), _c('i', [_vm._v("Christianity Today")]), _vm._v("'s Top 100 Books of the 20th Century, "), _c('i', [_vm._v("Basic Christianity")]), _vm._v(" has informed the faith of countless readers worldwide.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Stott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John Stott (1921–2011) was rector emeritus of All Souls Church, Langham Place, London, and founder of the London Institute for Contemporary Christianity.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0